import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { LoginComponent } from '../login/login.component';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '../icon/icon.component';
import { MatDialogRef } from '@angular/material/dialog';
import { ModalResult } from '../../interfaces/modal-result.interface';

@Component({
  selector: 'login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LoginComponent, TranslatePipe, IconComponent],
})
export class LoginModalComponent {
  dialogRef = inject(MatDialogRef<LoginModalComponent, ModalResult>);
}
